import { get, post } from './Api'

// Weight Discrepancy Business API Service Functions

/**
 * Get paginated list of weight discrepancy invoices
 * @param status - Filter by status: 'sent', 'paid', 'overdue' (default: 'sent')
 * @param page - Page number (default: 1)
 * @param limit - Items per page (default: 10)
 * @returns Promise with invoices data
 */
export const getInvoices = async (
  status: string = 'sent',
  page: number = 1,
  limit: number = 10,
) => {
  try {
    const response = await get(
      `business_admin/weight-discrepancy/invoices?status=${status}&page=${page}&limit=${limit}`,
    )
    return response
  } catch (error) {
    throw error
  }
}

/**
 * Get detailed information about a specific discrepancy invoice
 * @param invoiceId - The ID of the invoice
 * @returns Promise with invoice details
 */
export const getInvoiceDetails = async (invoiceId: string) => {
  try {
    const response = await get(
      `business_admin/weight-discrepancy/invoices/${invoiceId}`,
    )
    return response
  } catch (error) {
    throw error
  }
}

/**
 * Get business's complete weight discrepancy transaction history
 * @param page - Page number (default: 1)
 * @param limit - Items per page (default: 10)
 * @returns Promise with trail data
 */
export const getTrail = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await get(
      `business_admin/weight-discrepancy/trail?page=${page}&limit=${limit}`,
    )
    return response
  } catch (error) {
    throw error
  }
}

/**
 * Pay a weight discrepancy invoice
 * @param invoiceId - The ID of the invoice to pay
 * @param method - Payment method: 'wallet' or 'credit'
 * @returns Promise with payment result
 */
export const payInvoice = async (invoiceId: string, method: string) => {
  try {
    const response = await post(
      'business_admin/weight-discrepancy/pay',
      { invoiceId, method },
      null, // Token is handled by post function if null is passed
    )
    return response
  } catch (error) {
    throw error
  }
}
